import React, { useEffect, useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import ActiveList from './ActiveList';
import InActiveList from './InActiveList';
import AdminHeader from '../../../components/header/AdminHeader';
import AddEditListModal from './AddEditListModal';
import { useUserRolePermission } from '../../../store/slices/authSlice';
import { checkModulePermission } from '../../../utils/common';

const Lists = () => {
  const [activeTab, setActiveTab] = useState('1');
  const [openAddModal, setOpenAddModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isApiCall, setIsApiCall] = useState(null);
  const [isEdit, setIsEdit] = useState(null);
  const [activeFilter, setActiveFilter] = useState(undefined);
  const [inActiveFilter, setInActiveFilter] = useState(undefined);

  const userRolePermission = useUserRolePermission();

  useEffect(() => {
    setActiveFilter(undefined);
    setInActiveFilter(undefined);
  }, [activeTab]);

  return (
    <div>
      <AdminHeader
        title="Lists"
        isAdd
        isExpandSearch
        addBtnName="Add List"
        onAddClick={() => setOpenAddModal(true)}
        isAddDisabled={!checkModulePermission('is_add', 'Lists', userRolePermission)}
        searchPlaceholder="Search Lists"
        search={activeTab === '1' ? activeFilter : inActiveFilter}
        handelSearch={(e) => {
          if (activeTab === '1') {
            setActiveFilter(e.target.value);
          } else {
            setInActiveFilter(e.target.value);
          }
        }}
      />
      <div className="lists-container">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === '1' ? 'active' : ''}
              onClick={() => setActiveTab('1')}>
              Active Lists
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === '2' ? 'active' : ''}
              onClick={() => setActiveTab('2')}>
              In-Active Lists
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <ActiveList
              activeTab={activeTab}
              isApiCall={isApiCall}
              setOpenAddModal={setOpenAddModal}
              setIsEdit={setIsEdit}
              setEditRecord={setEditRecord}
              search={activeFilter}
            />
          </TabPane>
          <TabPane tabId="2">
            <InActiveList
              activeTab={activeTab}
              isApiCall={isApiCall}
              setOpenAddModal={setOpenAddModal}
              setIsEdit={setIsEdit}
              setEditRecord={setEditRecord}
              search={inActiveFilter}
            />
          </TabPane>
        </TabContent>
      </div>
      <AddEditListModal
        isOpen={openAddModal}
        onCloseClick={(apiCall = false) => {
          setOpenAddModal(false);
          setEditRecord(null);
          setIsEdit(false);
          if (apiCall) {
            setIsApiCall(Math.random());
          }
        }}
        editRecord={editRecord}
        isEdit={isEdit}
      />
    </div>
  );
};

export default Lists;
